module.exports = __webpack_public_path__ + "static/media/mangaa1.1b225c7b.png";